import React, { memo } from 'react'

import FooterLinks from './FooterLinks'
import { PlurixIcon } from './Icons'
import { useStoreContext } from '../../../contexts/StoreContext'
import useWindowDimensions from '../../../hooks/useWindowDimensions'

import './footer.scss'
import type { FooterPaymentMethodsProps } from '../../../types/CMS'

function Footer() {
  const { logo, storeInfos, footerPaymentMethods } = useStoreContext()
  const { isMobile } = useWindowDimensions()
  const isViewFooterClub = document?.location?.pathname?.includes('/club')
  const isMultipleSearchPage =
    document?.location?.pathname?.includes('/busca-multipla')

  if (isMultipleSearchPage && isMobile) {
    return null
  }

  return (
    <footer className="footer / grid-content-full">
      <div className="footer__section grid-content">
        <div className="footer-container">
          <FooterLinks />
        </div>
      </div>

      <div className="footer-payment-methods-container">
        <h2> Meios de Pagamento </h2>
        <ul className="footer-payment-methods">
          {!!footerPaymentMethods &&
            footerPaymentMethods?.map((item: FooterPaymentMethodsProps) => (
              <li key={item.name}>
                <img src={item.icon} alt={item.name} />
              </li>
            ))}
        </ul>
      </div>

      <div
        className={`footer__note-container ${
          isViewFooterClub && 'footer__note-container-club'
        }`}
      >
        <div className="footer__note-content grid-content">
          <img src={logo?.image} width={134} alt={logo?.alt} />

          <p>
            A VENDA E O CONSUMO DE BEBIDAS ALCOÓLICAS SÃO PROIBIDOS PARA MENORES
            DE 18 ANOS. BEBIDA ALCOÓLICA PODE CAUSAR DEPENDÊNCIA QUÍMICA E, EM
            EXCESSO, PROVOCA GRAVES MALES À SAÚDE. BEBA COM MODERAÇÃO. SE BEBER
            NÃO DIRIJA. Preços, ofertas e condições exclusivas para internet e
            válidos durante o dia de hoje, podendo sofrer alterações sem prévia
            notificação. No caso de faltar algum produto, este não será entregue
            e o valor correspondente não será cobrado. A venda está diretamente
            ligada à disponibilidade de estoque no dia do faturamento, já os
            produtos que serão enviados aos clientes estão sujeitos à
            disponibilidade de estoque no momento da separação. As fotos dos
            produtos no site são ilustrativas, podendo haver divergência com o
            produto real e todos os pedidos estão sujeitos à confirmação de
            dados dos clientes. {storeInfos.infos}
          </p>

          <div className="footer__developed">
            <span>Desenvolvido por</span>
            <PlurixIcon />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default memo(Footer)
